import React from "react";
import { Link } from "react-router-dom";
import Emojis from "../emojis/Emojis";
const Header = ({ search = true }) => {
  return (
    <div className="header">
      <Link to="/">
        <h1>
          React Em
          <Emojis data="SMILING_FACE_WITH_HEART_EYE" />
          jis
        </h1>
      </Link>
      <p>
        Pick up Em
        <Emojis data="FACE_WITH_TONGUE_1" />
        ji
      </p>
    </div>
  );
};

export default Header;
